export enum MetricGrouping {
    ChannelAndQueue = 1,
    Channel,
    Queue,
    Summary,
}
